import { render, staticRenderFns } from "./Security.vue?vue&type=template&id=207d15c6&scoped=true"
var script = {}
import style0 from "./Security.vue?vue&type=style&index=0&id=207d15c6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "207d15c6",
  null
  
)

export default component.exports